<template>
<!-- 
Added an integrated label.
Solved a value type issue.

Changes:
- Added the `label` property.
- Added the `inlineLabel` property.
- Added the `form-group` div.
- Added CSS.
- Added Number to the accepted value types
-->

<div>
  <div class="form-group mb-1" :class="{'inline-label': inlineLabel}" v-if="label">
      <label>{{ label }}</label>
  </div>
  <label class="custom-toggle" :class="switchClass">
    <input type="checkbox" v-model="model">
    <span class="custom-toggle-slider rounded-circle"
          :data-label-off="offText"
          :data-label-on="onText">
    </span>
  </label>
</div>
</template>
<script>
  export default {
    name: 'base-switch',
    props: {
      value: [Array, Boolean, Number],
      type: String,
      onText: {
        type: String,
        default: 'Yes'
      },
      offText: {
        type: String,
        default: 'No'
      },
      label: {
        type: String,
        default: null
      },
      inlineLabel: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      switchClass() {
        let baseClass = 'custom-toggle-';
        if (this.type) {
          return baseClass + this.type
        }
        return ''
      },
      model: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        }
      }
    },
    methods: {
      triggerToggle() {
        this.model = !this.model;
      }
    }
  };
</script>

<style scoped>

    .form-group label {
        color: #525f7f;
        font-size: 0.875rem;
        font-weight: 600;
    }
    .form-group.inline-label {
      display: inline-block;
      position: relative;
      top: -8px;
      margin-right: 5px;
    }

</style>
